import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", null, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("h2", null, "Welcome to Coop Finance", -1)
  ]))]))
}